import type { ClientListItem, Pagination } from "@shared/models";

export interface ClientList {
  client_list: ClientListItem[];
  pagination: Pagination;
}
